import { FC } from 'react'
import { Sun } from '@mailstep/design-system/ui/Elements/Icon/icons/Sun'
import { Moon } from '@mailstep/design-system/ui/Elements/Icon/icons/Moon'
import { CircleHalfStroke } from '@mailstep/design-system/ui/Elements/Icon/icons/CircleHalfStroke'
import { SvgProps } from '@mailstep/design-system/ui/Elements/Icon/types'
import { ThemeMode } from '../../../contexts/ThemeModeContext/ThemeModeContext'

export const STORAGE_KEY = 'mailship-theme-mode'
export const THEME_MODE_VALUES: string[] = [ThemeMode.Light, ThemeMode.Dark, ThemeMode.Auto]

export const themeModeOptions: { mode: ThemeMode; icon: FC<SvgProps>; labelId: string; labelDefault: string }[] = [
  { mode: ThemeMode.Light, icon: Sun, labelId: 'themeMode.light', labelDefault: 'Light' },
  { mode: ThemeMode.Dark, icon: Moon, labelId: 'themeMode.dark', labelDefault: 'Dark' },
  { mode: ThemeMode.Auto, icon: CircleHalfStroke, labelId: 'themeMode.auto', labelDefault: 'Auto' },
]

export const activeIconMap: Record<ThemeMode, FC<SvgProps>> = {
  [ThemeMode.Light]: Sun,
  [ThemeMode.Dark]: Moon,
  [ThemeMode.Auto]: CircleHalfStroke,
}
